import { useCatalog } from "./catalog";
import { GROUP_NAMES, type Group } from "./types";

/** Human names for the integer ids stored on account rows. */
export function useNames() {
  const catalog = useCatalog();
  const regions = new Map(catalog.data?.regions.map((region) => [region.id, region.name]) ?? []);
  const sites = new Map(catalog.data?.sites.map((site) => [site.id, site]) ?? []);
  const rooms = new Map(catalog.data?.rooms.map((room) => [room.id, room]) ?? []);
  return {
    catalog,
    groupName: (group: Group) => GROUP_NAMES[group],
    regionName: (id: number) => regions.get(id) ?? `区域 ${id}`,
    siteName: (id: number) => sites.get(id)?.name ?? `考点 ${id}`,
    roomName: (id: number | null | undefined) => id === null || id === undefined ? "—" : rooms.get(id)?.name ?? `考场 ${id}`
  };
}
